/**
 * Environment-namespaced PieSocket room names — the browser half of the
 * backend's ``piehost_room`` (dentalcrm apps/utils/piehost.py).
 *
 * Staging shares production's PieHost cluster, so legacy room names the browser
 * builds itself (``{practiceId}_notifications``, ``{practiceId}_{phoneNumberId}``)
 * would otherwise collide across environments. Staging sets
 * ``VITE_REACT_APP_SOCKET_ROOM_PREFIX=stg_``; production leaves it unset, so
 * every production room name is unchanged. Must match the backend's
 * ``PIEHOST_ROOM_PREFIX`` exactly, or the token minted for a room won't match
 * the room subscribed to.
 *
 * Idempotent (a backend-supplied room that is already prefixed is left as-is),
 * and ``v2r_`` rooms — HMAC-unique per environment — are never prefixed.
 */
export const SOCKET_ROOM_PREFIX = import.meta.env.VITE_REACT_APP_SOCKET_ROOM_PREFIX || '';

const UNPREFIXED_ROOM_PREFIXES = ['v2r_'];

export const pieRoom = (room, prefix = SOCKET_ROOM_PREFIX) => {
    const name = String(room ?? '');
    if (!prefix || !name || name.startsWith(prefix)) return name;
    if (UNPREFIXED_ROOM_PREFIXES.some((p) => name.startsWith(p))) return name;
    return `${prefix}${name}`;
};
